/* ════════════════════════════════════════════
   Kaalp Studios — Card Slider & Quick Buy JS
   ════════════════════════════════════════════ */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initQuickBuyModal();
    initGlobalSliderDelegation();
  });

  // Handle browser Back button (bfcache) navigation
  window.addEventListener('pageshow', function() {
    // Reset all loading states
    document.querySelectorAll('.is-loading').forEach(function(el) {
      el.classList.remove('is-loading');
    });
    // Re-enable any disabled buttons
    document.querySelectorAll('[data-quick-add-bag], [data-quick-buy-now]').forEach(function(btn) {
      btn.disabled = false;
      var textEl = btn.querySelector('.quick-buy-modal__btn-text');
      if (textEl && btn.hasAttribute('data-quick-buy-now')) textEl.textContent = 'BUY NOW';
      if (textEl && btn.hasAttribute('data-quick-add-bag')) textEl.textContent = 'ADD TO BAG';
    });
    // Close modal if open
    var modal = document.getElementById('quick-buy-modal');
    if (modal) {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('no-scroll');
    document.body.classList.remove('kaalp-loading');
    document.documentElement.classList.remove('kaalp-loading');
    var loader = document.getElementById('kaalp-site-loader');
    if (loader) loader.classList.add('is-hidden');
  });

  /* ──────────────────────────────────────────────
     1. CARD MULTI-IMAGE SLIDER (Global Delegation)
     ────────────────────────────────────────────── */
  function initGlobalSliderDelegation() {
    document.addEventListener('click', function(e) {
      var prevBtn = e.target.closest('[data-card-slider-prev]');
      var nextBtn = e.target.closest('[data-card-slider-next]');
      var dot = e.target.closest('[data-dot-index]');

      if (!prevBtn && !nextBtn && !dot) return;

      e.preventDefault();
      e.stopPropagation();

      var trigger = prevBtn || nextBtn || dot;
      var card = trigger.closest('[data-product-card]');
      if (!card) return;

      var track = card.querySelector('[data-card-slider-track]');
      var slides = card.querySelectorAll('[data-slide-index]');
      var dots = card.querySelectorAll('[data-dot-index]');
      var total = slides.length;

      if (total <= 1 || !track) return;

      var current = parseInt(card.getAttribute('data-current-slide') || '0', 10);
      if (isNaN(current)) current = 0;

      if (prevBtn) {
        current = current - 1;
        if (current < 0) current = total - 1;
      } else if (nextBtn) {
        current = current + 1;
        if (current >= total) current = 0;
      } else if (dot) {
        current = parseInt(dot.getAttribute('data-dot-index'), 10);
        if (isNaN(current)) current = 0;
      }

      card.setAttribute('data-current-slide', current);
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === current);
      });
    });

    // Touch Swipe on mobile
    var startX = 0;
    var startY = 0;
    var distX = 0;
    var distY = 0;
    var currentCard = null;

    document.addEventListener('touchstart', function(e) {
      var wrapper = e.target.closest('[data-card-slider-wrapper]');
      if (!wrapper) return;
      currentCard = wrapper.closest('[data-product-card]');
      var touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      distX = 0;
      distY = 0;
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
      if (!startX || !startY || !currentCard) return;
      var touch = e.touches[0];
      distX = touch.clientX - startX;
      distY = touch.clientY - startY;
    }, { passive: true });

    document.addEventListener('touchend', function() {
      if (!currentCard || !startX) return;

      if (Math.abs(distX) > 40 && Math.abs(distX) > Math.abs(distY)) {
        var track = currentCard.querySelector('[data-card-slider-track]');
        var slides = currentCard.querySelectorAll('[data-slide-index]');
        var dots = currentCard.querySelectorAll('[data-dot-index]');
        var total = slides.length;

        if (total > 1 && track) {
          var current = parseInt(currentCard.getAttribute('data-current-slide') || '0', 10);
          if (isNaN(current)) current = 0;

          if (distX < 0) {
            // Swiped left -> next
            current = (current + 1) >= total ? 0 : current + 1;
          } else {
            // Swiped right -> prev
            current = (current - 1) < 0 ? total - 1 : current - 1;
          }

          currentCard.setAttribute('data-current-slide', current);
          track.style.transform = 'translateX(-' + (current * 100) + '%)';

          dots.forEach(function(d, i) {
            d.classList.toggle('is-active', i === current);
          });
        }
      }

      startX = 0;
      startY = 0;
      distX = 0;
      distY = 0;
      currentCard = null;
    }, { passive: true });
  }

  /* ──────────────────────────────────────────────
     2. QUICK BUY MODAL CONTROLLER
     ────────────────────────────────────────────── */
  function initQuickBuyModal() {
    var modal = document.getElementById('quick-buy-modal');
    if (!modal) return;

    var titleEl = modal.querySelector('[data-quick-title]');
    var priceEl = modal.querySelector('[data-quick-price]');
    var comparePriceEl = modal.querySelector('[data-quick-compare-price]');
    var sizesContainer = modal.querySelector('[data-quick-sizes]');
    var sizeGuideTrigger = modal.querySelector('[data-quick-size-guide-trigger]');
    var sizeChartPanel = modal.querySelector('[data-quick-size-chart]');
    var sizeChartImgWrap = modal.querySelector('[data-quick-size-chart-img-wrap]');
    var sizeChartImg = modal.querySelector('[data-quick-size-chart-img]');
    var sizeChartTable = modal.querySelector('[data-quick-size-chart-table]');
    var addBagBtn = modal.querySelector('[data-quick-add-bag]');
    var buyNowBtn = modal.querySelector('[data-quick-buy-now]');

    // Global Size Chart Modal Elements
    var globalSizeChartModal = document.querySelector('[data-size-chart-modal]');
    var globalSizeChartImg = document.querySelector('[data-size-chart-modal-img]');

    var currentVariants = [];
    var selectedVariant = null;
    var currentSizeChartSrc = '';

    // Delegated click on '+' Quick Buy triggers
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-quick-buy-trigger]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      var card = trigger.closest('[data-product-card]');
      if (!card) return;

      openModal(card);
    });

    // Close button & backdrop handlers
    modal.querySelectorAll('[data-quick-buy-close]').forEach(function(el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (globalSizeChartModal && globalSizeChartModal.classList.contains('is-open')) {
          closeGlobalSizeChart();
        } else if (modal.classList.contains('is-active')) {
          closeModal();
        }
      }
    });

    // Open Size Guide from Quick Buy Modal
    if (sizeGuideTrigger) {
      sizeGuideTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        openGlobalSizeChart(currentSizeChartSrc);
      });
    }

    // Global Size Chart Modal Close handlers
    document.addEventListener('click', function(e) {
      var modal = document.querySelector('[data-size-chart-modal]');
      if (modal && modal.classList.contains('is-open')) {
        if (e.target === modal || e.target.closest('[data-size-chart-close]')) {
          closeGlobalSizeChart();
        }
      }
    });

    function openGlobalSizeChart(src) {
      var modal = document.querySelector('[data-size-chart-modal]');
      if (!modal) return;
      var img = modal.querySelector('[data-size-chart-modal-img]');
      var emptyMsg = modal.querySelector('[data-size-chart-modal-empty]');

      if (src) {
        if (img) {
          img.src = src;
          img.style.display = 'block';
        }
        if (emptyMsg) emptyMsg.style.display = 'none';
      } else {
        if (img) {
          img.src = '';
          img.style.display = 'none';
        }
        if (emptyMsg) emptyMsg.style.display = 'block';
      }

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeGlobalSizeChart() {
      var modal = document.querySelector('[data-size-chart-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Expose global helpers
    window.openSizeChartModal = openGlobalSizeChart;
    window.closeSizeChartModal = closeGlobalSizeChart;

    function openModal(card) {
      var title = card.getAttribute('data-product-title') || '';
      var price = card.getAttribute('data-product-price') || '';
      var comparePrice = card.getAttribute('data-product-compare-price') || '';
      currentSizeChartSrc = card.getAttribute('data-product-size-chart') || '';

      var variantsJsonEl = card.querySelector('[data-variants-json]');
      var optionsJsonEl = card.querySelector('[data-options-json]');

      currentVariants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];
      var options = optionsJsonEl ? JSON.parse(optionsJsonEl.textContent) : [];

      if (titleEl) titleEl.textContent = title;
      if (priceEl) priceEl.textContent = price;
      if (comparePriceEl) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.style.display = comparePrice ? 'inline-block' : 'none';
      }

      if (sizeChartPanel) sizeChartPanel.style.display = 'none';

      // Preload size chart image if available
      if (currentSizeChartSrc && sizeChartImg) {
        sizeChartImg.src = currentSizeChartSrc;
      }

      // Render Size Selection Pills
      renderSizes(currentVariants, options);

      // Open Modal
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      resetButtons();
    }

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      if (sizeChartPanel) sizeChartPanel.style.display = 'none';
      resetButtons();
    }

    function renderSizes(variants, options) {
      if (!sizesContainer) return;
      sizesContainer.innerHTML = '';

      if (!variants || variants.length === 0) return;

      // Check if it's a single "Default Title" variant
      if (variants.length === 1 && variants[0].title.indexOf('Default Title') !== -1) {
        selectedVariant = variants[0];
        var singleBtn = document.createElement('button');
        singleBtn.type = 'button';
        singleBtn.className = 'quick-buy-modal__size-pill is-selected';
        singleBtn.textContent = 'One Size';
        sizesContainer.appendChild(singleBtn);
        updateButtonsState();
        return;
      }

      // Find first available variant or first variant
      var firstAvail = variants.find(function(v) { return v.available; }) || variants[0];
      selectedVariant = firstAvail;

      variants.forEach(function(v) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'quick-buy-modal__size-pill' + 
          (v.id === selectedVariant.id ? ' is-selected' : '') +
          (!v.available ? ' is-disabled' : '');
        pill.setAttribute('data-variant-id', v.id);
        
        // Clean up title: if variant title is "M / Black", use the size portion
        var label = v.option1 || v.title;
        if (v.title.indexOf(' / ') !== -1) {
          var parts = v.title.split(' / ');
          label = parts[0];
        }
        pill.textContent = label;

        pill.addEventListener('click', function(e) {
          e.preventDefault();
          if (!v.available) return;

          selectedVariant = v;
          sizesContainer.querySelectorAll('.quick-buy-modal__size-pill').forEach(function(p) {
            p.classList.remove('is-selected');
          });
          pill.classList.add('is-selected');

          // Update price if variant has specific price
          if (priceEl && v.price) {
            priceEl.textContent = formatMoney(v.price);
          }
          if (comparePriceEl) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              comparePriceEl.textContent = formatMoney(v.compare_at_price);
              comparePriceEl.style.display = 'inline-block';
            } else {
              comparePriceEl.style.display = 'none';
            }
          }

          updateButtonsState();
        });

        sizesContainer.appendChild(pill);
      });

      updateButtonsState();
    }

    function updateButtonsState() {
      var isAvail = selectedVariant && selectedVariant.available;
      if (addBagBtn) {
        addBagBtn.disabled = !isAvail;
        addBagBtn.querySelector('.quick-buy-modal__btn-text').textContent = isAvail ? 'ADD TO BAG' : 'SOLD OUT';
      }
      if (buyNowBtn) {
        buyNowBtn.disabled = !isAvail;
        buyNowBtn.querySelector('.quick-buy-modal__btn-text').textContent = isAvail ? 'BUY NOW' : 'SOLD OUT';
      }
    }

    function resetButtons() {
      if (addBagBtn) {
        addBagBtn.classList.remove('is-loading');
        addBagBtn.disabled = false;
        var bagText = addBagBtn.querySelector('.quick-buy-modal__btn-text');
        if (bagText) bagText.textContent = 'ADD TO BAG';
      }
      if (buyNowBtn) {
        buyNowBtn.classList.remove('is-loading');
        buyNowBtn.disabled = false;
        var buyText = buyNowBtn.querySelector('.quick-buy-modal__btn-text');
        if (buyText) buyText.textContent = 'BUY NOW';
      }
    }

    function formatMoney(cents) {
      if (window.Theme && window.Theme.formatMoney) {
        return window.Theme.formatMoney(cents);
      }
      return 'Rs. ' + (cents / 100).toFixed(2);
    }

    // ── Handle ADD TO BAG ──
    if (addBagBtn) {
      addBagBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!selectedVariant || !selectedVariant.available) return;

        addBagBtn.classList.add('is-loading');
        if (buyNowBtn) buyNowBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(selectedVariant.id), quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          addBagBtn.classList.remove('is-loading');
          closeModal();

          // Dispatch event to open cart drawer & refresh header badges
          document.dispatchEvent(new CustomEvent('product:added', { detail: data }));
          if (window.Theme && window.Theme.Cart) {
            window.Theme.Cart.dispatchUpdate(data);
          }
        })
        .catch(function(err) {
          console.error('Add to bag error:', err);
          addBagBtn.classList.remove('is-loading');
          if (buyNowBtn) buyNowBtn.disabled = false;
        });
      });
    }

    // ── Handle BUY NOW ──
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!selectedVariant || !selectedVariant.available) return;

        buyNowBtn.classList.add('is-loading');
        if (addBagBtn) addBagBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(selectedVariant.id), quantity: 1 })
        })
        .then(function() {
          window.location.href = '/checkout';
        })
        .catch(function(err) {
          console.error('Buy now error:', err);
          buyNowBtn.classList.remove('is-loading');
          if (addBagBtn) addBagBtn.disabled = false;
        });
      });
    }
  }

})();
